import {
  DetailedHTMLProps,
  FC,
  FormHTMLAttributes,
  HTMLAttributes,
  PropsWithChildren,
} from "react";
import styled from "@emotion/styled";
import { ScreenSize } from "@constants/screen-size";
import { Box } from "@mui/material";
import { Link, LinkProps } from "react-router-dom";

const FormContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 48px;
  box-sizing: border-box;
  max-width: 500px;
  width: 100%;
  margin: auto;

  @media (max-width: ${ScreenSize.md}px) {
    padding: 20px;
  }
`;

const Title = styled.h1`
  font-size: 30px;
  line-height: 48px;
  font-weight: 500;
  color: #171a1fff;
  margin: 0 0 45px;
  text-align: center;
`;

const SubTitle = styled.h2`
  font-size: 14px;
  line-height: 22px;
  font-weight: 400;
  color: #171a1fff;
  margin: 0;
  text-align: center;
`;

export interface OnboardingFormProps {
  title?: string | JSX.Element | JSX.Element[];
  subtitle?: string | JSX.Element | JSX.Element[];
}

const PublicFormContainer = styled.form`
  display: flex;
  flex-direction: column;
  gap: 16px;
  margin-top: 40px;
  width: 100%;
`;

const PublicFormActionContainer = styled.div`
  box-sizing: border-box;
  margin: 48px auto 0;
  width: 90%;
`;

const PublicFormFooter = styled.div`
  font-size: 14px;
  margin-top: 24px;
  color: #828282;
  text-align: center;
`;

const PublicFormLink = styled(Link)`
  text-decoration: none;
  font-size: 14px;
  line-height: 22px;
  font-weight: 500;
  color: #1e64ddff;
  margin: 0 8px;
  white-space: nowrap;
`;

const PublicFormTos = styled.div`
  margin-top: 24px;
`;

const PublicForm: FC<PropsWithChildren<OnboardingFormProps>> & {
  PublicFormContainer: FC<
    DetailedHTMLProps<FormHTMLAttributes<HTMLFormElement>, HTMLFormElement>
  >;
  PublicFormActionContainer: FC<
    DetailedHTMLProps<HTMLAttributes<HTMLDivElement>, HTMLDivElement>
  >;
  PublicFormFooter: FC<
    DetailedHTMLProps<HTMLAttributes<HTMLDivElement>, HTMLDivElement>
  >;
  PublicFormLink: FC<LinkProps>;
  PublicFormTos: FC<
    DetailedHTMLProps<HTMLAttributes<HTMLDivElement>, HTMLDivElement>
  >;
} = ({ title, subtitle, children }) => {
  return (
    <FormContainer>
      {(title || subtitle) && (
        <Box width="100%">
          {title && <Title>{title}</Title>}
          {subtitle && <SubTitle>{subtitle}</SubTitle>}
        </Box>
      )}

      {children}
    </FormContainer>
  );
};

PublicForm.PublicFormContainer = PublicFormContainer;
PublicForm.PublicFormActionContainer = PublicFormActionContainer;
PublicForm.PublicFormFooter = PublicFormFooter;
PublicForm.PublicFormLink = PublicFormLink;
PublicForm.PublicFormTos = PublicFormTos;

export default PublicForm;
